import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoadingIndicatorService, ToastrService } from '@kpmg-tax/ui';
import { APP_ERROR_CODES, APP_ERROR_CONSTANTS } from 'src/app/shared/constants/app-constants';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { RightSideDrawerService } from 'src/app/shared/right-side-drawer/right-side-drawer.service';


@Injectable()
export class AppInterceptor implements HttpInterceptor {
    constructor(private _injector: Injector) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const loader = this._injector.get(LoadingIndicatorService);
        let headers: HttpHeaders = httpRequest.headers.get('FileUpload') !== null ? httpRequest.headers.delete('FileUpload')
            : httpRequest.headers.set('Content-Type', 'application/json');
        const newReq: HttpRequest<any> = httpRequest.clone({
            url: httpRequest.url,
            headers: headers,
            withCredentials: true
        });
        return next.handle(newReq).pipe(tap((event: HttpEvent<any>) => {
            if (event) { }
        }), catchError((errorResponse: HttpErrorResponse) => {
            const rightSideDrawerService = this._injector.get(RightSideDrawerService);
            rightSideDrawerService.loaderObsevable.next(false);
            loader.display(false);
            if (errorResponse.error instanceof ErrorEvent) {
            } else {
                if (!errorResponse.url.includes(API_URL.PING)) {
                    this.handleError(errorResponse.status, errorResponse.error, errorResponse.url);
                }
            }
            return throwError(() => errorResponse.error);
        }));
    }

    getErrorGuidFromErrorMessage(errorMessage: string) {
        let errorMessageWithGuid = ''
        if (errorMessage && errorMessage.length > 0) {
            let errorGuid = errorMessage.substring(errorMessage.indexOf('.') + 1)
            let indexLastGuidCharacter = errorGuid.indexOf('.');
            if (indexLastGuidCharacter !== -1) {
                errorGuid = errorGuid.substring(0, indexLastGuidCharacter);
                errorMessageWithGuid = errorGuid;
            }
        }
        return errorMessageWithGuid;
    }

    handleError(status: number, error: any, url : string) {
        const toaster = this._injector.get(ToastrService);
        switch (status) {
            case APP_ERROR_CODES.INTERNAL_SERVER_ERROR:
                if (error instanceof Blob) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        toaster.setErrorMessage(reader.result as string);
                    };
                    reader.onerror = () => {
                        toaster.setErrorMessage('Failed to read error');
                    };
                    reader.readAsText(error);
                    break;
                }
                toaster.setErrorMessage(error?.toString());
                break;
            case APP_ERROR_CODES.BAD_REQUEST:
                const errorMessage = error.errorMessage ? error.errorMessage : APP_ERROR_CONSTANTS.BAD_REQUEST;
                toaster.setErrorMessage(errorMessage.toString());
                break;
            case APP_ERROR_CODES.FORBIDDEN:
                if (url.includes(API_URL.GETPERMISSIONS) || url.includes(API_URL.PING) || url.includes(API_URL.CLIENT.GET_USER_FOR_HELP_EMAIL) || url.includes(API_URL.PAGEFEEDBACK.GETPAGEFEEDBACKS) || url.includes(API_URL.ENGAGEMENT.GETENGAGEMENTBYID)){
                    toaster.setWarningMessage(APP_ERROR_CONSTANTS.FORBIDDEN_USER);                    
                } else {
                    let errorGuid = this.getErrorGuidFromErrorMessage(error?.toString());
                    toaster.setErrorMessage(errorGuid + APP_ERROR_CONSTANTS.SYSTEM_ERROR);
                }
                break;
            default:
                let errorGuid = this.getErrorGuidFromErrorMessage(error?.toString());
                toaster.setErrorMessage(errorGuid + APP_ERROR_CONSTANTS.SYSTEM_ERROR);
                break;
        }
    }
}

